import { Model as t } from "../../../model.js";
class u extends t {
  constructor(s) {
    super(), this.skuCode = s.skuCode, this.name = s.name, this.quantity = s.quantity, this.subtotal = s.subtotal, this.taxes = s.taxes, this.total = s.total;
  }
}
export {
  u as TicketItemModifierModel
};
//# sourceMappingURL=ticketItemModifier.model.js.map
